// Signup
export const ONBOARDING_CRITERIA = 'onboardingCriteria'
export const ONBOARDING_CURRENT_STEP = 'onboardingCurrentStep'

// Temporary component states
export const ADDRESS_AUTOCOMPLETE_USED = 'addressAutocompleteUsed'

// Auth Session
export const AUTH_SESSION_KEY = 'tangoPortalAuthSessionTimeout'
